function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "49.996%",
  y1: "1.431%",
  x2: "49.996%",
  y2: "96.981%",
  id: "a"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFE513",
  offset: ".562%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FDB924",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "4.512%",
  y1: "13.494%",
  x2: "95.672%",
  y2: "87.064%",
  id: "b"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#008CD2",
  offset: ".562%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00649D",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50.002%",
  y1: "27.779%",
  x2: "50.002%",
  y2: "97.529%",
  id: "c"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#26A146",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#008A52",
  offset: "100%"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "43.734%",
  y1: "8.208%",
  x2: "57.544%",
  y2: "93.198%",
  id: "d"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D92231",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BA2234",
  offset: "100%"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#E79225",
  d: "M104 7.668v24.691l-3.413 3.336V11.532z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF16D",
  d: "M81.636 7.688l-3.534 3.844.182.244 22.161-.081.203-.163L104 7.668z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  d: "M.102 4.007h22.547V28.19H.102z",
  transform: "translate(78 7.525)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.216 20.237a8.944 8.944 0 0 0-1.991-3.01c-.833-.854-1.767-1.505-2.823-1.932a8.74 8.74 0 0 0-3.372-.65 8.842 8.842 0 0 0-3.392.65c-1.057.427-1.991 1.078-2.824 1.932a8.886 8.886 0 0 0-1.97 3.01c-.447 1.119-.65 2.34-.65 3.682 0 1.301.223 2.522.67 3.66a9.05 9.05 0 0 0 1.97 3.052 8.254 8.254 0 0 0 2.783 1.891c1.036.427 2.194.65 3.433.65a8.711 8.711 0 0 0 3.352-.65 8.62 8.62 0 0 0 2.823-1.891 9.23 9.23 0 0 0 1.99-3.031c.447-1.119.67-2.36.67-3.661 0-1.363-.223-2.583-.67-3.702zm-4.652 7.973c-.873 1.037-2.031 1.566-3.534 1.566-1.503 0-2.682-.529-3.555-1.566-.873-1.037-1.3-2.481-1.3-4.312 0-1.87.447-3.315 1.3-4.373.873-1.057 2.031-1.566 3.555-1.566 1.503 0 2.66.53 3.534 1.566.853 1.058 1.3 2.502 1.3 4.373 0 1.83-.427 3.275-1.3 4.312z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#009ADA",
  d: "M75.888 5.654v.122l2.884 22.19-1.686 4.678-.223-.163-2.966-21.274.06-.285 1.85-5.146z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#91C9ED",
  d: "M53.686 8.746l22.201-3.092-1.868 5.33-.264.284-20.76 3.05.102-3.803z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#b)",
  d: "M21.816 5.492l3.067 21.66-21.877 3.072L.061 9.294l1.28-.996z",
  transform: "translate(52.203 5.492)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M70.302 15.132c-.102-.671-.325-1.18-.691-1.525a1.626 1.626 0 0 0-1.097-.407c-.101 0-.223 0-.345.02-.569.082-.996.346-1.26.773-.203.305-.284.692-.284 1.14 0 .162.02.345.04.528l.793 5.634-6.297.936-.792-5.634c-.102-.651-.325-1.16-.69-1.505a1.537 1.537 0 0 0-1.077-.428c-.102 0-.204 0-.305.02-.59.082-1.036.347-1.32.774-.204.305-.285.691-.285 1.139 0 .162.02.345.04.549l2.154 14.664c.102.671.325 1.18.731 1.526.305.264.67.386 1.117.386.122 0 .244 0 .366-.02.548-.082.955-.346 1.219-.773.183-.305.264-.671.264-1.098 0-.163-.02-.346-.04-.53l-.874-5.796 6.297-.936.873 5.797c.102.671.325 1.18.711 1.505.305.265.67.407 1.097.407.101 0 .223 0 .345-.02.569-.082.996-.346 1.26-.773.182-.305.284-.671.284-1.119 0-.163-.02-.346-.04-.529l-2.194-14.705z",
  fill: "#FFF"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#66BF6B",
  d: "M32.906 0l-7.901 18.793 1.076 8.258.061-.02L35.02 7.037l-.04-.427-1.91-6.346z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#98D0A0",
  d: "M32.906 0l2.052 6.895.04.142 19.541 8.766.061-.04-1.666-6.59z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#c)",
  d: "M9.973 6.895l19.643 8.868-8.877 20.156L1.097 27.05z",
  transform: "translate(24.984)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.648 17.39c-.426-1.14-1.015-2.115-1.787-2.929a8.322 8.322 0 0 0-2.803-1.932 8.337 8.337 0 0 0-3.311-.692h-.061c-1.138 0-2.255.265-3.352.753a8.961 8.961 0 0 0-3.006 2.115c-.853.895-1.544 1.993-2.072 3.254a10.9 10.9 0 0 0-.873 3.743v.427c0 1.098.183 2.176.569 3.234a8.198 8.198 0 0 0 1.767 2.888c.772.813 1.726 1.464 2.864 1.932a8.171 8.171 0 0 0 3.29.692h.02c1.118 0 2.235-.244 3.332-.712a9.098 9.098 0 0 0 3.027-2.136 10.565 10.565 0 0 0 2.092-3.234c.528-1.26.812-2.501.873-3.742v-.366a8.802 8.802 0 0 0-.569-3.295zm-3.92 5.857c-.731 1.75-1.726 2.95-2.925 3.6-.65.346-1.32.53-1.99.53-.59 0-1.22-.143-1.849-.408-1.381-.59-2.234-1.525-2.6-2.867a5.317 5.317 0 0 1-.183-1.404c0-.976.244-2.054.732-3.213.751-1.79 1.746-3.01 2.945-3.682a4.003 4.003 0 0 1 1.99-.528c.61 0 1.22.142 1.87.406 1.36.59 2.213 1.526 2.579 2.868.122.427.183.895.183 1.383 0 1.017-.244 2.115-.752 3.315z",
  fill: "#FFF"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#760D16",
  d: "M23.44 3.193l3.21 21.519-1.462 7.566-.204-.264-3.128-20.787v-.407l1.381-7.26z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EF463E",
  d: "M0 14.319l1.523-7.607 21.918-3.519-1.483 7.75v.508L.264 14.522z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#d)",
  d: "M21.958 7.892l3.23 21.335-21.694 3.397L0 11.268z",
  transform: "translate(0 3.05)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.622 28.881c-.163-.203-.406-.345-.69-.447-.285-.102-.63-.142-1.057-.142-.386 0-.833.04-1.32.122l-5.728.976c.06-.448.284-1.017.67-1.729.426-.793 1.076-1.75 1.91-2.847.284-.387.507-.672.67-.875.101-.142.264-.325.467-.59 1.32-1.729 2.112-3.132 2.437-4.23.183-.63.285-1.261.325-1.892.02-.183.02-.346.02-.508a7.5 7.5 0 0 0-.121-1.343c-.061-.407-.163-.732-.305-.996-.142-.265-.305-.468-.508-.59-.223-.143-.569-.204-.995-.204-.345 0-.772.041-1.28.122l-6.622 1.14c-.792.142-1.401.366-1.767.732a1.4 1.4 0 0 0-.447 1.057c0 .102 0 .224.02.346.102.57.386.976.854 1.18.284.122.61.183 1.015.183.264 0 .57-.02.894-.082l5.525-.976c0 .102.02.204.02.285 0 .346-.06.691-.182 1.017-.163.468-.57 1.118-1.24 1.952-.182.224-.467.59-.853 1.058-1.503 1.81-2.559 3.356-3.209 4.637-.467.895-.772 1.75-.955 2.624a7.317 7.317 0 0 0-.162 1.444c0 .326.02.65.081.956.081.447.183.814.325 1.098.142.285.345.509.569.63.223.123.528.164.975.164.548 0 1.3-.082 2.255-.245l6.012-1.037c1.056-.183 1.808-.447 2.234-.793.346-.285.529-.671.529-1.119 0-.122-.02-.244-.041-.366a1.349 1.349 0 0 0-.325-.712z",
  fill: "#FFF"
})));

var SvgZohoDocs = function SvgZohoDocs(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 36,
    viewBox: "0 0 104 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgZohoDocs, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/zoho_docs.5f9db8a3.svg";
export { ForwardRef as ReactComponent };